export const DOTS_ELEMENTS_GAP = 2;

export const DOTS_VISIBLE_COUNT = 4;

export const DOTS_ELEMENT_WIDTH = 6;

export const DOTS_ELEMENT_HEIGHT = 6;

export const DOTS_REAR_GAP = 1;

export const TOTAL_DOTS_WIDTH = (DOTS_VISIBLE_COUNT + 1) * DOTS_ELEMENT_WIDTH;

export const SPACE_BETWEEN_DOTS = DOTS_ELEMENTS_GAP * (DOTS_VISIBLE_COUNT + 1);

export const MAX_WIDTH = TOTAL_DOTS_WIDTH + SPACE_BETWEEN_DOTS;
